<template>
	<div>
		<div class="modal-header">
		    <div class="modal-title">
		        <a-icon type="medicine-box" style="margin-right:10px" />
		        <span>{{this.isEdit?l('Edit'):l('Create')}}</span>
		    </div>
		</div>
		<div>
		    <a-config-provider :locale="antdLocale">
				<a-row>
				    <a-col :span="24">
						<a-form-item required :label-col="{ span: 7 }" :wrapper-col="{ span: 9 }" :label="l('Name')">
							<a-input v-model="entity.name" class="input"></a-input>
						</a-form-item>
				    </a-col>
					<a-col :span="24" style="margin-top: -10px;">
					    <a-form-item :label-col="{ span: 7 }" :wrapper-col="{ span: 9 }" :label="l('Code')">
					    	<a-input v-model="entity.code" class="input"></a-input>
					    </a-form-item>
					</a-col>
					<a-col :span="24" style="margin-top: -10px;">
					    <a-form-item :label-col="{ span: 7 }" :wrapper-col="{ span: 9 }" :label="l('pid')">
							<a-tree-select
							        v-model="pId"
							        style="width: 200px"
							        :tree-data="treeDataList"
							        :replace-fields="treeReplaceFields"
							        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
							        :placeholder="l('please_select_the_superior_node')"
							        allow-clear
							        tree-default-expand-all
							>
							</a-tree-select>
					    </a-form-item>
					</a-col>
					<a-col :span="24" style="margin-top: -10px;">
						<a-form-item :label-col="{ span: 7 }" :wrapper-col="{ span: 9 }" :label="l('planEnd')">
							<a-input-number
								v-model="formattedPlanEnd"
								:formatter="value => `${value}` + l('day')"  
								:parser="value => value.replace(l('day'), '')"  
								:min="0"
								:placeholder="l('Please_enter_the_planned_completion_days')"
								style="width: 200px;"
							/>
						</a-form-item>
					</a-col>
					<a-col :span="24" style="margin-top: -10px;">
						<a-checkbox  v-model="canModifyTime" style="margin-left: 104px;overflow: hidden;text-overflow: ellipsis;">
							{{l('Can_the_planned_time_be_modified')}}
						</a-checkbox>
					</a-col>
				</a-row>
			</a-config-provider>
		</div>
		<div class="modal-footer" v-if="!isLook">
		    <a-button @click="close">
		        {{l('Cancel')}}
		    </a-button>
		    <a-button :type="'primary'" @click="save">
		        {{l('Save')}}
		    </a-button>
		</div>
	</div>
</template>

<script>
	import ModalComponentBase from '../../../../shared/component-base/modal-component-base';
	import zh_CN from 'ant-design-vue/lib/locale/zh_CN';
	import { IssueTypeServiceProxy,IssueTypeEditDto } from '../../../../shared/service-proxies';
	
	let _this;
	export default {
		name: 'new-issue',
		mixins: [ModalComponentBase],
		components: {},
		created() {
		    this.fullData(); // 模态框必须,填充数据到data字段
		    this.IssueTypeServiceProxy = new IssueTypeServiceProxy(this.$apiUrl, this.$api);
		},
		mounted() {
		    this.getData();
			this.getTreeData();
		},
		data() {
		    return {
				zh_CN,
		        isEdit: false,//是否是编辑
		        isLook: false,//是否是查看
		        entity: {}, //初始化为空对象
				a: new IssueTypeEditDto(),
				pId: undefined,
				treeDataList: [],
				treeReplaceFields: {
				    title: 'name',
				    key: 'id',
				    value: 'id'
				},
				isclick: true,
				formattedPlanEnd: 0,
				canModifyTime: true
		    }
		},
		watch: {
			'entity.planFinishTime'(newVal) {
				if (newVal !== undefined) {
					const num = parseInt(newVal.toString().replace(/天/g, ''), 10);
					this.formattedPlanEnd = isNaN(num) ? 0 : num;
				}
			}
		},
		methods: {
			getData() {
				this.isLoading = true;
				this.IssueTypeServiceProxy.getForEdit(this.id)
					.finally(() => {
						this.isLoading = false;
					})
					.then(res => {
						console.log("后端返回数据：", res);
						this.entity = res.issueType || {};
						
						// pId 处理逻辑
						if (this.entity.pId === 0) {
							this.pId = undefined;
						} else {
							this.pId = this.entity.pId;
						}
						this.formattedPlanEnd = this.entity.planFinishTime || 0;
						if(this.entity.id) {
							this.canModifyTime = this.entity.canModifyTime;
						}
					})
			},
			getTreeData() {
			    this.isLoading = true;
			    this.IssueTypeServiceProxy.getPaged(undefined)
			        .finally(() => {
			            this.isLoading = false;
			        })
			        .then((res) => {
			            this.treeDataList = JSON.parse(JSON.stringify(res)) || [];
			        })
			},
			save() {
				// 1. 基础校验
				if (!this.entity.name) {
					abp.message.info('分类名称不能为空');
					return;
				}
				if (this.isEdit && this.pId === this.id) {
					abp.message.info(this.l('You_cannot_choose_yourself_as_the_superior_node'));
					return;
				}
				if (this.formattedPlanEnd < 0) {
					abp.message.info('计划完成天数不能为负数');
					return;
				}
				this.entity.planFinishTime = this.formattedPlanEnd;
				this.entity.canModifyTime = this.canModifyTime;
				console.log("最终提交给后端的数据：", this.entity);

				// 2. pId 处理
				this.entity.pId = this.pId === undefined ? 0 : this.pId;

				// 3. 提交数据
				const issueType = { issueType: this.entity };
				if (this.isclick) {
					this.isclick = false;
					this.IssueTypeServiceProxy.createOrUpdate(issueType)
						.finally(() => {
							this.close();
						})
						.then(res => {
							this.isclick = true;
							this.success(true);
						})
						.catch(err => {
							this.isclick = true;
							abp.message.error(`提交失败：${err.message || '未知错误'}`);
						})
				}
			},
		}
	}
</script>

<style>
	.input {
		width: 200px;
	}
</style>
<!-- 888 -->
